"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("grid", className, styles.root),
        rowContainer: styling_1.mergeStyles("grid-row-container", styles.rowContainer),
        row: styling_1.mergeStyles("grid-row", styles.row),
        cell: styling_1.mergeStyles("grid-cell", styles.cell)
    };
});
exports.getClassNames = getClassNames;
